/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _module = __webpack_require__(1);
	
	// テスト
	var _isTest = false;
	var preTweetScore = 0;
	var nowTweetScore = 0; //preload
	
	(0, _module.preload)(); //pageTop
	
	(0, _module.pageTop)();
	$(window).on('load', function () {
	  scrollIndexAnime();
	  $(".answer_Item").click(function () {
	    var select_item = $(this).attr("id");
	    var res_arr = select_item.split("_");
	    var answer_chk = "#result_" + res_arr[1];
	    var answer_chk2 = res_arr[2];
	    answer_chk_func(this, select_item, answer_chk, answer_chk2);
	  });
	
	  function answer_chk_func(_this, select_item, answer_chk, answer_chk2) {
	    var result_val = "";
	    var q_num = answer_chk.replace("#result_", "");
	
	    if ($(answer_chk).text() == "") {
	      var a_num;
	      var _isCorrect = false;
	      var score = $("#score").text();
	      var tweet_url = $("#twitter_button").attr("href");
	
	      if (q_num === "01") {
	        a_num = "4";
	      } else if (q_num === "02") {
	        a_num = "1";
	      } else if (q_num === "03") {
	        a_num = "1";
	      } else if (q_num === "04") {
	        a_num = "3";
	      } else if (q_num === "05") {
	        a_num = "4";
	      }
	
	      if (a_num === answer_chk2) {
	        _isCorrect = true;
	      }
	
	      if (_isCorrect) {
	        score = parseInt($("#count").text(), 10);
	        score++;
	        $("#count").text(score);
	        preTweetScore = (score - 1) * 20;
	        nowTweetScore = score * 20;
	        tweet_url = tweet_url.replace("%E3%81%82%E3%81%AA%E3%81%9F%E3%81%AE%E4%BD%90%E8%B3%80%E7%90%86%E8%A7%A3%E5%BA%A6%E3%81%AF" + preTweetScore + "%25", "%E3%81%82%E3%81%AA%E3%81%9F%E3%81%AE%E4%BD%90%E8%B3%80%E7%90%86%E8%A7%A3%E5%BA%A6%E3%81%AF" + nowTweetScore + "%25");
	        $("#twitter_button").attr("href", tweet_url);
	        $("li#" + select_item).addClass("current");
	        result_val = $('input:hidden[name="' + "comment-t_" + q_num + '"]').val();
	        result_val = decodeURIComponent(escape(atob(result_val)));
	        $("#comment").addClass('score_Box_Comment-' + nowTweetScore);
	        result_val = '<div class="explanation"><div class="result_Messeage result_Messeage-red">正解!</div><div class="result_Description">' + result_val + "</div></div>";
	        $(answer_chk).html(result_val);
	      } else {
	        $("li#" + select_item).addClass("current");
	        result_val = $('input:hidden[name="' + "comment-f_" + q_num + '"]').val();
	        result_val = decodeURIComponent(escape(atob(result_val)));
	        result_val = '<div class="explanation"><div class="result_Messeage result_Messeage-blue">不正解...</div><div class="result_Description">' + result_val + "</div></div>";
	        $(answer_chk).html(result_val);
	      }
	    } else {
	      return false;
	    }
	  }
	}); // ------------------------------------------------------------------------
	// scrollIndexAnime
	// ----- BOTH
	// ------------------------------------------------------------------------
	
	var scrollIndexAnime = function scrollIndexAnime() {
	  var controller = new ScrollMagic.Controller(); //ページトップ出現
	
	  var scene = new ScrollMagic.Scene({
	    triggerElement: '.index-Story',
	    triggerHook: 1,
	    offset: '80'
	  }).setClassToggle('#st-Top', 'st-Top-Show').addTo(controller); //　スクロールで発火系
	
	  var targets = document.querySelectorAll(".js-scrollAnimation");
	  var targetsArray = Array.prototype.slice.call(targets); //Array
	
	  targetsArray.forEach(function (target) {
	    //シーンを作成
	    new ScrollMagic.Scene({
	      triggerElement: target,
	      triggerHook: 1,
	      offset: '250'
	    }) // .on("enter", function (event) {  // シーンの状態が"DURING"に入る際に発火する
	    //   // console.log("Scene entered.");
	    //   $(target).toggleClass("is-animated");
	    //   setTimeout(function(){
	    //     $(target).toggleClass("is-completed");
	    //   },1000);
	    // })
	    .setClassToggle(target, "is-animated").addTo(controller);
	  });
	};

/***/ }),
/* 1 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.pageTop = exports.preload = void 0;
	
	// ------------------------------------------------------------------------
	// preload
	// ----- BOTH
	// ------------------------------------------------------------------------
	var preload = function preload() {
	  $('body').addClass('preload');
	  $(window).on('load', function () {
	    $("body").removeClass("preload");
	  });
	}; // ------------------------------------------------------------------------
	// pageTop
	// ----- BOTH
	// ------------------------------------------------------------------------
	
	
	exports.preload = preload;
	
	var pageTop = function pageTop() {
	  $("#st-Top").on("click", function () {
	    var linkSpeed = 800;
	    $("html, body").animate({
	      scrollTop: 0
	    }, linkSpeed, "easeOutExpo");
	    return false;
	  });
	};
	
	exports.pageTop = pageTop;

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// index/app.bundle.js